import { ThirdTitleComponent } from './titles/third-title/third-title.component';
import { PictureComponent } from './sections/media/pictures/picture/picture.component';
import { InfoComponent } from './sections/info/info.component';
import { ParagraphComponent } from './sections/paragraph/paragraph.component';
import { BaseComponent } from './base/base.component';
import { SecondaryTitleComponent } from './titles/secondary-title/secondary-title.component';
import { MainTitleComponent } from './titles/main-title/main-title.component';
import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { InstagramComponent } from './sections/media/instagram/instagram.component';
import { MentionComponent } from './sections/mention/mention.component';
import { ArticleLinkComponent } from './sections/article-link/article-link.component';
import { IframeComponent } from './sections/iframe/iframe.component';
import { ButtonComponent } from './sections/button/button.component';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {
  components: { [key: string]: any } = {
    'main-title': MainTitleComponent,
    'secondary-title': SecondaryTitleComponent,
    'third-title': ThirdTitleComponent,
    paragraph: ParagraphComponent,
    info: InfoComponent,
    picture: PictureComponent,
    instagram: InstagramComponent,
    mention: MentionComponent,
    articleLink: ArticleLinkComponent,
    iframe: IframeComponent,
    button: ButtonComponent
  };

  constructor() {}

  resolveComponent(
    viewContainerRef: ViewContainerRef,
    name: string
  ): ComponentRef<BaseComponent<any>> {
    const component = this.components[name];
    return viewContainerRef.createComponent(component);
  }
}
